export default __webpack_public_path__ + "static/media/blog-thumb-1.1010d35e.png";